const componentsUtils = {
    loadAsyncComponent: (domElement) => {
        document.dispatchEvent(new CustomEvent('loadAsyncComponent', { detail: domElement }));
    },
};
export default componentsUtils;
